import React, { useState, useEffect, useRef, KeyboardEvent, ChangeEvent } from 'react';
import './style.css';

export enum LineType {
  Input,
  Output
}

export enum ColorMode {
  Light,
  Dark
}

export interface Props {
  name?: string
  prompt?: string
  colorMode?: ColorMode
  lineData: Array<{type: LineType, value: string}>
  onInput: ((input: string) => void) | null | undefined
}

const Terminal = (props: Props) => {
  const [currentLineInput, setCurrentLineInput] = useState('');

  const lastLineRef = useRef<null | HTMLElement>(null)

  const updateCurrentLineInput = (event: ChangeEvent<HTMLInputElement>) => {
    setCurrentLineInput(event.target.value);
  }

  const handleEnter = (event: KeyboardEvent<HTMLInputElement>) => {
    if (props.onInput != null && event.key === 'Enter') {
      props.onInput(currentLineInput);
      setCurrentLineInput('');
    }
  }

  // An effect that handles scrolling into view the last line of terminal input or output
  useEffect(() => {
    setTimeout(() => lastLineRef?.current?.scrollIntoView({ behavior: "smooth" }), 500);
  }, [props.lineData.length]);

  // We use a hidden input to capture terminal input; make sure the hidden input is focused when clicking anywhere on the document
  useEffect(() => {
    document.onclick = () => document.getElementById("terminal-hidden")?.focus()
  });

  const renderedLineData = props.lineData.map((ld, i) => {
    const classes = ['react-terminal-line'];
    if (ld.type === LineType.Input) {
      classes.push('react-terminal-input');
    }
    if (props.lineData.length === i + 1 && props.onInput == null) {
      return (
        <span className={ classes.join(' ') } key={ i } ref={ lastLineRef }>{ ld.value }</span>
      );
    } else {
      return (
        <span className={ classes.join(' ') } key={ i }>{ ld.value }</span>
      );
    }
  });

  if (props.onInput != null) {
    renderedLineData.push(
      <span className="react-terminal-line react-terminal-input react-terminal-active-input" data-terminal-prompt={ props.prompt || '$' } key={ props.lineData.length } ref={ lastLineRef }>{ currentLineInput }</span>,
    );
  }

  const classes = ['react-terminal-wrapper'];
  if (props.colorMode === ColorMode.Light) {
    classes.push('react-terminal-light');
  }
  return (
    <div className={ classes.join(' ') } data-terminal-name={ props.name }>
      <div className="react-terminal">
        { renderedLineData }
      </div>
      <div className="hidden-input-wrapper">
        <div className="hidden-input">
          <label htmlFor="terminal-hidden">Terminal Hidden Input</label>
          <input id="terminal-hidden" value={ currentLineInput } autoFocus={ props.onInput != null } onChange={ updateCurrentLineInput } onKeyDown={ handleEnter } />
        </div>
      </div>
    </div>
  );
}

export default Terminal;
